import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';

export const useAppSelector = <T>(selector: (state: ApplicationState) => T): T => {
    return useSelector(selector);
};
